<template>
  <div>
    <div class="detial-cont-view">
      <a-descriptions layout="vertical">
        <a-descriptions-item>
          <span slot="label">单位名称<span class="required">*</span> </span>
          <a-tooltip placement="topLeft" :title="form.unitName">
            <div>
              <a-input
                v-if="form.id"
                class="w300"
                placeholder="请添加"
                v-model="form.unitName"
                disabled
              />
              <a-select
                v-else
                class="w300"
                placeholder="请选择"
                v-model="form.organizationId"
                :disabled="disabled"
              >
                <a-select-option
                  v-for="item in app.organizationUserList"
                  :value="item.organizationId"
                  :key="item.organizationId"
                >
                  {{ item.organizationname }}</a-select-option
                >
              </a-select>
            </div>
          </a-tooltip>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">主管领导<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请添加"
            v-model="form.leadership"
            :disabled="disabled"
            @change="emitChange('leadership', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">食堂管理员<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请添加"
            v-model="form.canteenAdmin"
            :disabled="disabled"
            @change="emitChange('canteenAdmin', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label"
            >食堂管理员联系方式<span class="required">*</span>
          </span>
          <a-input
            class="w300"
            placeholder="请添加"
            v-model="form.canteenAdminPhone"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label"
            >上岗人员是否持有健康证<span class="required">*</span>
          </span>
          <a-select
            @change="emitChange()"
            class="w300"
            v-model="form.healthCertificate"
            placeholder="请选择上岗人员是否持有健康证"
            :disabled="disabled"
          >
            <template v-for="(item, index) in bytype.whetherList">
              <a-select-option :value="item.valuename" :key="index">
                {{ item.keyname }}
              </a-select-option>
            </template>
          </a-select>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">使用燃料类型<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请添加"
            v-model="form.eldingType"
            :disabled="disabled"
            @change="emitChange('eldingType', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item label="贮气瓶数（瓶）">
          <a-input-number
            :min="0"
            :max="999999999"
            class="w300"
            placeholder="请添加"
            v-model="form.gasCylinder"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <a-descriptions-item label="贮气瓶存放位置">
          <a-input
            class="w300"
            placeholder="请添加"
            v-model="form.gasCylinderAddress"
            :disabled="disabled"
            @change="emitChange('gasCylinderAddress', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label"
            >是否有防火措施（烟感、燃气报警器）<span class="required">*</span>
          </span>
          <a-select
            @change="emitChange()"
            class="w300"
            v-model="form.firePreventionMeasure"
            placeholder="请选择是否有防火措施（烟感、燃气报警器）"
            :disabled="disabled"
          >
            <template v-for="(item, index) in bytype.whetherList">
              <a-select-option :value="item.valuename" :key="index">
                {{ item.keyname }}
              </a-select-option>
            </template>
          </a-select>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label"
            >本次烟道清洗时间<span class="required">*</span>
          </span>
          <a-date-picker
            @change="emitChange()"
            class="w300"
            v-model="form.rinseDate"
            valueFormat="YYYY-MM-DD"
            placeholder="请选择本次烟道清洗时间"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label"
            >烟道清洗周期（月）<span class="required">*</span>
          </span>
          <a-input-number
            :min="0"
            :max="999999999"
            class="w300"
            placeholder="请添加"
            v-model="form.rinsePeriod"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <br />

        <a-descriptions-item label="备注">
          <a-input
            class="w500"
            type="textarea"
            :auto-size="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入备注"
            v-model="form.remark"
            :disabled="disabled"
            @change="emitChange('remark', 200)"
          />
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  props: ['disabled', 'resData', 'formData'],
  model: {
    event: 'input',
    prop: 'formData'
  },
  data() {
    return {
      form: {}
    }
  },
  watch: {
    resData(val) {
      this.form = this.resData
    }
  },
  mounted() {
    this.getWhetherList()
    // 获取组织机构
    this.getorganizationUserList()
    if (!this.form.id) {
      // 新增
      this.$set(
        this.form,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  computed: {
    ...mapState(['bytype', 'app'])
  },
  methods: {
    ...mapActions(['getWhetherList', 'getorganizationUserList']),
    emitChange(v, maxNum) {
      if (v) {
        this.eightyfive(v, maxNum)
      }
      this.$emit('input', this.form)
    }, // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.form[v].length > maxNum) {
        this.form[v] = this.form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/baseInfoManagement/cantennManagement/components/formBaseInfo.vue